const SERVICE = "market";

const createTransaction = async (api, body) =>
  api.setService(SERVICE).client.request({
    method: "POST",
    data: body,
    url: `${api.service}/transaction`,
    headers: {
      ...api.optionsObject.headers,
      "Content-Type": "multipart/form-data",
    },
  });

const getInvoice = async (api, params) =>
  api.setMethod().get().setService(SERVICE).process("/invoice/:uuid", params);

const getTransactions = async (api, params) =>
  api.setMethod().get().setService(SERVICE).process("/transactions", params);

const getTransaction = async (api, uuid, params) =>
  api
    .setMethod()
    .get()
    .setService(SERVICE)
    .process(`/transaction/${uuid}`, params);

const updateAddress = async (api, body) =>
  api
    .setMethod()
    .post()
    .setService(SERVICE)
    .setBody(body)
    .process("/transaction/address");

const cartCheckout = async (api, body) =>
  api.setService(SERVICE).client.request({
    method: "POST",
    data: body,
    url: `${api.service}/transaction/checkout`,
    headers: {
      ...api.optionsObject.headers,
      "Content-Type": "multipart/form-data",
    },
  });

const delivery = async (api, body) =>
  api
    .setMethod()
    .post()
    .setService(SERVICE)
    .setBody(body)
    .process("/transaction/delivery");

const deliveryPricelist = async (api, body) =>
  api
    .setMethod()
    .post()
    .setService(SERVICE)
    .setBody(body)
    .process("/delivery/pricelist");
const getDeliveryProvider = async (api, id) =>
  api
    .setMethod()
    .get()
    .setService(SERVICE)
    .process(`/delivery/deliverylist?store_id=${id}`);

module.exports = {
  createTransaction,
  getInvoice,
  getTransactions,
  getTransaction,
  updateAddress,
  cartCheckout,
  delivery,
  deliveryPricelist,
  getDeliveryProvider,
};
